module.exports = __webpack_public_path__ + "img/kachel-ERSCHOEPFUNG_MINDMASERRED.e160beba.png";